import { useState, useEffect } from 'react';
import { Flex, Heading, Card } from '@blockanalitica/ui';
import { getConsentStatus, setConsentStatus } from '@/utils/cookieConsent';
import { CookieIcon } from '@/components';
import styled, { css } from 'styled-components';

const Wrapper = styled(Card)`
  position: fixed;
  z-index: 1000;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

  ${({ theme }) => css`
    bottom: ${theme.space['m']};
    right: ${theme.space['m']};
    background: ${theme.colors.fgPrimary};
    border: solid 1px ${theme.colors.fgSecondary};
  `}
`;

const AcceptButton = styled.button`
  border: none;
  margin: 0;
  font: inherit;
  text-align: inherit;
  text-decoration: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  background-image: linear-gradient(270.98deg, #ffcd4d -5.71%, #fa43bd 102.6%);
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;

  ${({ theme }) => css`
    color: ${theme.colors.text};
    border-radius: ${theme.sizes['-4']};
    padding: ${theme.space['2xs']} ${theme.space['s']};

    &:hover {
      background-color: ${theme.colors.text};
      background-image: unset;
      color: ${theme.colors.spark.black};
    }
  `};
`;

const DeclineButton = styled.button`
  border: none;
  margin: 0;
  font: inherit;
  text-align: inherit;
  text-decoration: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 600;

  ${({ theme }) => css`
    color: ${theme.colors.muted};
    border-radius: ${theme.sizes['-4']};
    padding: ${theme.space['2xs']} ${theme.space['s']};
    background-color: ${theme.colors.fgSecondary};

    &:hover {
      background-color: ${theme.colors.text};
      background-image: unset;
      color: ${theme.colors.spark.black};
    }
  `};
`;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsentStatus() === 'unset') {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setConsentStatus('granted');
    setVisible(false);
  };

  const handleDecline = () => {
    setConsentStatus('denied');
    setVisible(false);
  };

  return visible ? (
    <Wrapper width={['auto', '330px']} left={['m', 'auto']} gap="m">
      <Flex gap="s" justifyContent="flex-start">
        <Flex>
          <CookieIcon size="4" />
        </Flex>
        <Flex flexDirection="column" gap="2xs">
          <Heading fontSize="0">Cookies Policy</Heading>
          <Flex as="p" fontSize="-1" color="muted">
            We use cookies to ensure that we give you the best experience on our
            app. To learn more, visit our{' '}
            <Flex
              as="a"
              // @ts-ignore
              display="contents"
              href="https://spark.fi/privacy-policy"
              target="_blank"
              rel="noopener noreferrer">
              Privacy Policy
            </Flex>
            .
          </Flex>
        </Flex>
      </Flex>

      <Flex gap="s">
        <AcceptButton onClick={handleAccept}>Accept</AcceptButton>
        <DeclineButton onClick={handleDecline}>Decline</DeclineButton>
      </Flex>
    </Wrapper>
  ) : null;
}
